import { branchTermSingular } from 'utils/terminology';

const ThreePLMessage = ({ threePLType, customClass }) => {
  switch (threePLType) {
    case 'Segen':
      return (
        <p className={customClass || 'cef-message__text'}>
          To find out more about our full range of renewable products and for
          quotations and orders please contact{' '}
          <a href="/renewables">CEF Renewables</a> or your local{' '}
          {branchTermSingular}.
        </p>
      );

    default:
      return (
        <p className={customClass || 'cef-message__text'}>
          This product requires special delivery. Please call, email or visit
          your local {branchTermSingular} to place an order.
        </p>
      );
  }
};

export default ThreePLMessage;
